// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file health_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file health_service.proto.
 */
export const file_health_service: GenFile = /*@__PURE__*/
  fileDesc("ChRoZWFsdGhfc2VydmljZS5wcm90bxIGZG9tYWluIg0KC1BpbmdSZXF1ZXN0Ig4KDFBpbmdSZXNwb25zZTJECg1IZWFsdGhTZXJ2aWNlEjMKBFBpbmcSEy5kb21haW4uUGluZ1JlcXVlc3QaFC5kb21haW4uUGluZ1Jlc3BvbnNlIgBCMFouZ2l0bGFiLmNvbS9jb3RlY2hkZS9tb25vcmVwby9iYWNrZW5kL2RvbWFpbi9wYmIGcHJvdG8z");

/**
 * @generated from message domain.PingRequest
 */
export type PingRequest = Message<"domain.PingRequest"> & {
};

/**
 * Describes the message domain.PingRequest.
 * Use `create(PingRequestSchema)` to create a new message.
 */
export const PingRequestSchema: GenMessage<PingRequest> = /*@__PURE__*/
  messageDesc(file_health_service, 0);

/**
 * @generated from message domain.PingResponse
 */
export type PingResponse = Message<"domain.PingResponse"> & {
};

/**
 * Describes the message domain.PingResponse.
 * Use `create(PingResponseSchema)` to create a new message.
 */
export const PingResponseSchema: GenMessage<PingResponse> = /*@__PURE__*/
  messageDesc(file_health_service, 1);

/**
 * @generated from service domain.HealthService
 */
export const HealthService: GenService<{
  /**
   * @generated from rpc domain.HealthService.Ping
   */
  ping: {
    methodKind: "unary";
    input: typeof PingRequestSchema;
    output: typeof PingResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_health_service, 0);

